<app-website-header></app-website-header>

<div class="signup-container">
  <div class="background-container">
    <div class="signup-form-header-container">
      <div class="signup-form-logo">
        <img src="./../../../assets/images/Frame 534.svg" />
      </div>
      <div class="signup-form-banner-container">
        <div style="max-width: 1000px; position: relative; top:-5px;">
          <span class="signup-form-title">Signup with Us</span>
          <div style="text-align: justify; position: relative;  "><b>Sign up to explore medical equipment and the latest
              innovations, connect with top OEMs and trusted providers, and discover job opportunities.</b></div>
        </div>
      </div>
    </div>

    <div class="signup-main-container">
      <div class="row signup-Page">
        <div class="col-lg-7 col-md-12 col-sm-12 signup-left" *ngIf="emailSent">
          <form class="form-conatiner" (ngSubmit)="submitForm(form)" #form="ngForm">

            <div class="row">
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <p class="top-text">Account Type<span class="required-asterisk">*</span></p>
                <select class="input-field" name="account" (change)="onAccountChange($event)">
                  <option value="" disabled selected>Select Account Type</option>
                  <option *ngFor="let type of accounttypevalues" [value]="type">{{ type }}</option>
                </select>
                <div *ngIf="!selectedAccountCategory && isProceed" class="error-message"
                  style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span class="error-message">Account Type is required.</span>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-12">
                <p class="top-text">Account<span class="required-asterisk">*</span></p>
                <mat-form-field appearance="outline" style="width: 100%;">
                  <input matInput [matAutocomplete]="accountAuto" class="select-account"
                  placeholder="Select Account Type" [formControl]="accountTypeControl" autocomplete="off"
                  #accountAutocompleteTrigger="matAutocompleteTrigger" (input)="filterAccountTypes($event)"
                  (blur)="validateAccountTypeOnBlur()" [matAutocompleteDisabled]="!selectedAccountCategory" />
                  <mat-autocomplete #accountAuto="matAutocomplete" (optionSelected)="onAccountTypeSelected($event)">
                    <mat-option *ngFor="let code of filteredAccountTypes" [value]="code.id">
                      {{ code.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <div *ngIf="accountTypeControl.invalid && accountTypeControl.touched" class="error-message"
                  style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span class="error-message account-error">Account is required.</span>
                </div>
              </div>
            </div>
            <div *ngIf="!isindividual" class="hospitalname">
              <label class="label-styles" for="">Name of the Organization <span
                  class="required-asterisk">*</span></label><br />
              <input style="width: 100%;" class="input-field" autocomplete="new-password" type="text"
                [(ngModel)]="UserSignup.organization" name="hospitalname" required #HospitalName="ngModel"
                (ngModelChange)="validateField(HospitalName, 'organization')" placeholder="Enter Organization" />

              <div
                *ngIf="HospitalName?.touched && HospitalName?.errors?.['required'] || (HospitalName?.errors?.['required'] && isProceed)"
                class="error-message" style="display: flex; align-items: center">
                <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                <span style="margin-left: 5px" class="error-message">Organization name is required.</span>
              </div>
              <div
                *ngIf="(HospitalName?.errors?.['invalidOrganization'] || HospitalName?.errors?.['invalidOrganizationLength'])"
                class="error-message">
                <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                <span class="error-message">
                  {{ HospitalName?.errors?.['invalidOrganization'] ? 'Only Alphanumerics are allowed' : 'Limit Exceeded:
                  Max 150 characters' }}
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">First Name<span class="required-asterisk">*</span></label><br />
                <input class="input-field" type="text" [(ngModel)]="UserSignup.firstName" name="firstName" required
                  autocomplete="new-password" #firstNameField="ngModel"
                  (ngModelChange)="validateField(firstNameField, 'firstName')" style="width: 100%;"
                  placeholder="Enter First Name" />
                <div
                  *ngIf="firstNameField?.touched && firstNameField?.errors?.['required'] || (firstNameField?.errors?.['required'] && isProceed)"
                  class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">First name is required.</span>
                </div>
                <div
                  *ngIf="firstNameField?.touched && firstNameField?.errors?.['invalidName'] || firstNameField?.errors?.['invalidNameLength']"
                  class="error-message">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span class="error-message">
                    {{ firstNameField?.errors?.['invalidName'] ? 'Only Alphabets are allowed' : 'Limit Exceeded: Max 50
                    characters' }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">Last Name<span class="required-asterisk">*</span></label><br />
                <input class="input-field" type="text" [(ngModel)]="UserSignup.lastName" name="lastName" required
                  autocomplete="new-password" #lastNameField="ngModel"
                  (ngModelChange)="validateField(lastNameField, 'lastName')" style="width: 100%;"
                  placeholder="Enter Surname" />
                <div
                  *ngIf="lastNameField?.touched && lastNameField?.errors?.['required'] || (lastNameField?.errors?.['required'] && isProceed)"
                  class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span style="margin-left: 5px">Last name is required.</span>
                </div>
                <div
                  *ngIf="lastNameField?.touched && lastNameField?.errors?.['invalidName'] || lastNameField?.errors?.['invalidNameLength']"
                  class="error-message">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span class="error-message">
                    {{ lastNameField?.errors?.['invalidName'] ? 'Only Alphabets are allowed' : 'Limit Exceeded: Max 50
                    characters.' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">Email<span class="required-asterisk">*</span></label><br />
                <input class="input-field" type="email" style="width: 100%;" [(ngModel)]="UserSignup.email" name="email"
                  required #emailField="ngModel" (ngModelChange)="emailValidation(UserSignup.email)"
                  autocomplete="new-password" placeholder="Enter Email" />
                <div
                  *ngIf="emailField?.touched && emailField?.errors?.['required'] || (emailField?.errors?.['required'] && isProceed)"
                  class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">Email is required.</span>
                </div>

                <div *ngIf="emailInvalid && emailField?.value" class="error-message"
                  style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">
                    Invalid Email.</span>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">Phone<span class="required-asterisk">*</span></label><br />
                <div class="row" style="display: flex;">
                  <div style="display: flex; flex-direction: column;">
                    <div class="input-group rounde outline-none" style="border-radius: 6px; flex-wrap: nowrap;"
                      (click)="showOptions=true">
                      <input class="input-field" placeholder="IN" #countryCode="ngModel"
                        style="border-radius: 6px 0px 0px 6px; width: 60px; text-transform: uppercase;"
                        aria-label="Select your country code" [value]="countryCode" [(ngModel)]="UserSignup.countryCode"
                        name="countryCode" required (input)="filterOptions(UserSignup.countryCode)"
                        (click)="filterOptions(UserSignup.countryCode)" (ngModelChange)="onlyText2($event)"
                        (focus)="showOptions = true" (blur)="validateCountryCodeOnBlur()" autocomplete="new-password"
                        maxlength="2" #countryCodeInput>
                      <span class="dropdown-arrow">▾</span>
                      <div style="width: 75px; outline: none;" class="custom-dropdown" *ngIf="showOptions">
                        <ul>
                          <li class="no-outline" style="width: 60px;" *ngFor="let code of filteredCountryCodes"
                            (click)="selectOption(code)">
                            {{ code.countryCode | uppercase }}
                          </li>
                        </ul>
                      </div>
                      <input type="text" class="border-0 no-interaction text-center no-outline" style="width: 60px;"
                        placeholder="+91" [(ngModel)]="UserSignup.phoneCode" name="phoneCode" #phoneCodeField="ngModel"
                        readonly>
                      <input type="text" class="border-0 no-interaction no-outline"
                        style="width: 100%; border-top-right-radius: 6px; border-bottom-right-radius: 6px;"
                        [(ngModel)]="UserSignup.phoneNumber" name="phoneNumber" #phonenumberfield="ngModel"
                        (ngModelChange)="phonenumbervalidation(UserSignup.phoneNumber); numberOnly($event)"
                        placeholder="Enter Phone Number" required>
                    </div>
                    <div *ngIf="phonenumberfield?.invalid && phonenumberfield?.touched" class="error-message"
                      style="display: flex; align-items: center;">
                      <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                      <span style="margin-left: 5px" class="error-message">Phone Number is required.</span>
                    </div>
                    <div *ngIf="countryCode?.invalid && countryCode?.touched" class="error-message"
                      style="display: flex; align-items: center;">
                      <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                      <span style="margin-left: 5px" class="error-message">Country Code is required.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div *ngIf="!isindividual" class="col-md-12 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">Website<span class="required-asterisk">*</span></label><br />
                <input class="input-field" style="width: 100%;" autocomplete="new-password" type="text"
                  [(ngModel)]="UserSignup.website" name="website" #websiteField="ngModel" (keyup)="validateUrl($event)"
                  placeholder="Enter Website URL" required />
                <div
                  *ngIf="websiteField?.touched && websiteField?.errors?.['required'] || (websiteField?.errors?.['required'] && isProceed)"
                  class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">Website is required.</span>
                </div>
                <div *ngIf="websiteField?.value && urlInvalid" class="error-message"
                  style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">Please enter a valid URL that starts with "http",
                    "https" or "www."</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">Password<span class="required-asterisk">*</span></label><br />
                <div class="d-flex" style="position: relative;">
                  <input class="input-field" [type]="showPassword ? 'text' : 'password'" name="password" required
                    [(ngModel)]="UserSignup.password" #passwordField="ngModel"
                    (ngModelChange)="passwordValidation(UserSignup.password)" (cut)="preventCopyPaste($event)"
                    (copy)="preventCopyPaste($event)" (paste)="preventCopyPaste($event)"
                    (contextmenu)="preventContextMenu($event)" autocomplete="new-password"
                    style="border-radius:6px; width: 100%;" placeholder="Enter Password" />
                  <button type="button" class="eye-button  bg-transparent" (click)="showPassword = !showPassword"
                    style="border:none; position: absolute;">
                    <img class="eye-icon" loading="lazy" alt=""
                      [src]="showPassword ? './../../../../assets/images/Eye.svg' : './../../../../assets/images/Blind.svg'" /></button>
                </div>
                <div
                  *ngIf="passwordField?.touched && passwordField?.errors?.['required'] || passwordField?.errors?.['required'] && isProceed"
                  class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">Password is required.</span>
                </div>
                <div *ngFor="let error of passwordValidation(UserSignup.password)" class="error-message"
                  style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">
                    {{error}}</span>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-12 inside-fields">
                <label class="label-styles" for="">Confirm Password<span class="required-asterisk">*</span>
                </label><br />

                <div class="d-flex" style="position: relative;">
                  <input class="input-field" [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword"
                    required [(ngModel)]="UserSignup.confirmPassword" #confirmPasswordField="ngModel"
                    (cut)="preventCopyPaste($event)" (copy)="preventCopyPaste($event)"
                    (paste)="preventCopyPaste($event)" (contextmenu)="preventContextMenu($event)"
                    style="border-radius:6px; width: 100%;" placeholder="Enter Confirm Password" />
                  <button type="button" class="eye-button  bg-transparent"
                    (click)="showConfirmPassword = !showConfirmPassword" style="border:none; position: absolute;">
                    <img class="eye-icon" style="background-color: none;border:none;" loading="lazy" alt=""
                      [src]="showConfirmPassword ? './../../../../assets/images/Eye.svg' : './../../../../assets/images/Blind.svg'" /></button>
                </div>
                <div
                  *ngIf="confirmPasswordField?.touched && confirmPasswordField?.errors?.['required'] || confirmPasswordField?.errors?.['required'] && isProceed"
                  class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">Confirm password is required.</span>
                </div>
                <div *ngIf="
                      UserSignup.password !== UserSignup.confirmPassword &&
                      confirmPasswordField?.touched && !confirmPasswordField?.errors?.['required']
                    " class="error-message" style="display: flex; align-items: center">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  <span style="margin-left: 5px" class="error-message">Passwords should be match.</span>
                </div>
              </div>
            </div>
            <div class="additional-content">
              <div class="checkbox-container">
                <input type="checkbox" id="sampleCheckbox" name="confirmPassword" required
                  (change)="updateSignupButtonState($event)" />
                <label for="sampleCheckbox">&nbsp;I agree to Medworld Expo's
                  <a routerLink="/terms-and-conditions" style="color: #0d87c8">Terms of Use</a> and
                  <a routerLink="/privacy-policy" style="color: #0d87c8">Privacy policy</a> and
                  <a routerLink="/refund-policy" style="color: #0d87c8">Refund policy</a>
                </label><br />
              </div>
              <button type="submit" class="button-styles button-primary"
                [style.opacity]="isSignupButtonEnabled ? '1' : '0.5'" [disabled]="!isSignupButtonEnabled">
                Sign Up
              </button>
            </div>
            <div *ngIf="badRequest" class="error-message" style="display: flex; align-items: center">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
              <span style="margin-left: 5px" class="error-message">{{ errorMessage }}</span>
            </div>
            <div class="signin-link">
              <p style="font-size: 14px;">Already have an account? <a routerLink="/login" class="links">Sign in</a></p>
            </div>
          </form>
        </div>
        <div class="mailsent d-flex text-center align-items-center p-0">
          <div class="col-lg-7 col-md-12 col-sm-12 signup-left" *ngIf="!emailSent">
            <div class="verification-container">
              <div class="verification-text mb-3">
                <p>Verify your email</p>
              </div>
              <div class="verification-message mb-3">
                <p>Hi {{ UserSignup.lastName }}, Please verify your email address by clicking the link sent to<br />{{
                  UserSignup.email }}
              </div>
              <div class="resend-button mb-3">
                <button (click)="resendVerificationMail()" class="button">Resend Verification Email</button>
              </div>
              <div class="support-email mb-3">
                <p style="line-height: 24px">Questions? Email us at<br /><span>{{refEmail}}</span></p>
              </div>
              <button routerLink="/login" style="width: 40%;border: 1px solid #0d87c8; background-color: #ffffff;color: #0d87c8;
              border-radius: 7px;padding: 5px;font-size:16px;">Go To Login</button>
            </div>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 signup-right">
            <div class="top-right">
              <p class="top-text" style="color: #0d87c8;text-align: left;">
                Why Choose Medworld Expo
              </p>
              <div class="signup-leads">
                <img src="assets/images/webinar.png" alt="" />
                <div class="text">
                  <p class="role" style="text-align: left;"><b>
                      Exclusive Webinars, CMEs and Career Options
                    </b></p>
                </div>
              </div>
              <div class="signup-leads">
                <img src="assets\images\social-services.png" alt="" />
                <div class="text">
                  <p class="role" style="text-align: left;"><b>
                      Interactive Health Communities
                    </b></p>
                </div>
              </div>
              <div class="signup-leads">
                <img src="assets\images\customer-engagement.png" alt="" />
                <div class="text">
                  <p class="role" style="text-align: left;"><b>
                      Enhanced Collaboration Opportunities
                    </b></p>
                </div>
              </div>
              <div class="signup-leads">
                <img src="assets\images\analytics.png" alt="" />
                <div class="text">
                  <p class="role" style="text-align: left;"><b>
                      Up-to-Date Industry Insights
                    </b></p>
                </div>
              </div>
            </div>
            <div class="bottom-right">
              <img class="distributor-bottom-img" src="../../../../assets/images/end-customer-signup.jpg" alt="">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<div class="ourmission-section d-flex justify-content-center align-items-center p-0 gap-4" style="margin: 29px 20px;">
  <div class="mission-image">
    <img src="../../../../assets/images/our_mission.jpg" alt="mission image">
  </div>
  <div class="mission-text d-flex flex-column" style="gap: 10px;">
    <span class="mission-title" style="margin-bottom: 10px;"><strong>Our Mission</strong></span>
    <div style="display: flex;  font-size: 14px; ">
      <span><img src="/assets/images/right-arrow.svg" class="img-color">&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;
      <li style="list-style-type:none; text-align: justify;">To revolutionize the health-care industry by providing a
        premier digital platform for seamless interaction.</li>


    </div>
    <div style="display: flex;  font-size:  14px;  ">
      <span><img src="/assets/images/right-arrow.svg" class="img-color">&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;
      <li style="list-style-type:none; text-align: justify;">Commit to empowering Manufacturers, Distributors, and
        Health Care Providers with cutting-edge tools for growth and connectivity.</li>

    </div>
    <div style="display: flex; font-size: 14px; ">
      <span><img src="/assets/images/right-arrow.svg">&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;<li
        style="list-style-type:none; text-align: justify;">Dedicated to nurturing a vibrant ecosystem where the medical
        community thrives together.</li>
    </div>
    <div style="display: flex; font-size: 14px; ">
      <span><img src="/assets/images/right-arrow.svg">&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;<li
        style="list-style-type:none; text-align: justify;">Foster continuous learning and professional growth through
        our comprehensive Knowledge Centre.</li>
    </div>
    <div style="display: flex; font-size:  14px;">
      <span><img src="/assets/images/right-arrow.svg">&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;<li
        style="list-style-type:none; text-align: justify;">Facilitate career advancement by offering a platform for job
        opportunities and professional networking within the medical industry.</li>

    </div>

  </div>
</div>
<app-website-footer></app-website-footer>